import type { Dayjs } from 'dayjs';
import dayjs from 'dayjs';
import calendar from 'dayjs/plugin/calendar';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(calendar);
dayjs.extend(localizedFormat);

import { parseDate } from '@utilities/dateTime';
import { Trace } from '@utilities/logging';

export type ToLocalTimePluginOptions = {
  targetDate?: string;
};
const defaults: ToLocalTimePluginOptions = {
  targetDate: '',
};

export default class ToLocalTimePlugin {
  dom: HTMLElement;
  opt: ToLocalTimePluginOptions;

  constructor(dom: HTMLElement, o: ToLocalTimePluginOptions) {
    this.opt = {
      ...defaults,
      ...o,
    };
    this.dom = dom;
  }

  init() {
    if (!this.opt.targetDate) return;

    Array.from(this.dom.querySelectorAll<HTMLElement>('.js-tolocaltime')).forEach(this.setDate);

    if (this.dom.matches('.js-tolocaltime')) {
      this.setDate(this.dom);
    }
  }

  setDate = (e: HTMLElement) => {
    const date = parseDate(this.opt.targetDate);

    const tag = e.dataset.tag;
    const cal = e.dataset.calendar;

    const res = this.getDateString(date, tag, cal);

    e.innerText = res;
  };

  detach() {
    Trace('ok');
  }

  getDateString(date: Dayjs, tag: string, cal: string) {
    if (cal) {
      const formats = JSON.parse(cal) as object;
      if (formats) {
        return date.calendar(null, formats);
      }
    }

    return date.format(tag);
  }
}
